import luckyDrawPrizeDialog from './luckyDrawPrizeDialog.container'

export default luckyDrawPrizeDialog